const AgroforestryProject = {
  "_format": "hh-sol-artifact-1",
  "contractName": "AgroforestryProject",
  "sourceName": "contracts/core/AgroforestryProject.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "ACTIVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_APPROVED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_SIGNED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_WITHDRAWN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AMOUNT_TOO_LOW",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUDIT_MARK_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_AUDITOR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_FACTORY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_FARMER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_TOKEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_INPUT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_PRICE_PRECISION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_TO",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_EXISTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_LOCKED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "DEPOSIT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EMPTY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZE_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "HIGH_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_STAGE_RESERVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_TOTAL_RESERVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_STAGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_YEARS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN_COSTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN_PRICES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MARK_FAILED_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_COST",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_PRICE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_REVENUE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MINT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_APPROVED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_SIGNED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_ACTIVE_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PROJECT_ENDED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PROJECT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "RESERVED_FUNDS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SPECIES_LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SSTORE2_WriteError",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_DONE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_NOT_FUNDED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_PARAMS_MISSING",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKENS_EXIST",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKEN_CONFIG_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_TIMESTAMP",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "YEAR_LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDRESS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AMOUNT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AUDITOR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_CONFIG",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_FARMER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_PREDICTED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_TOKEN",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "FundsWithdrawn",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "quantity",
          "type": "uint64"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "pricePerUnit",
          "type": "uint64"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "revenue",
          "type": "uint64"
        }
      ],
      "name": "HarvestRecorded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensReceived",
          "type": "uint256"
        }
      ],
      "name": "Invested",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "ProjectCompleted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "ProjectFailed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "name": "RefundPaid",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalRealized",
          "type": "uint256"
        }
      ],
      "name": "RevenueDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "maxYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "speciesCount",
          "type": "uint8"
        }
      ],
      "name": "SpeciesConfigSeeded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "predicted",
          "type": "uint128"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "realized",
          "type": "uint128"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        }
      ],
      "name": "SpeciesFinalized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIndex",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextAuditYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextAuditStageIndex",
          "type": "uint8"
        }
      ],
      "name": "StageAudited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIndex",
          "type": "uint8"
        }
      ],
      "name": "StageMoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIndex",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextSignYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextSignStageIndex",
          "type": "uint8"
        }
      ],
      "name": "StageSigned",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "maxYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageCount",
          "type": "uint8"
        }
      ],
      "name": "StagesSeeded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "approved",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditStage",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditWindowOpen",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditor",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "canRefundStage",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint128",
          "name": "predictedRevenue",
          "type": "uint128"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "configureSpecies",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint8[]",
          "name": "_years",
          "type": "uint8[]"
        },
        {
          "internalType": "uint128[]",
          "name": "predictedRevenues",
          "type": "uint128[]"
        },
        {
          "internalType": "uint64[]",
          "name": "claimTimestamps",
          "type": "uint64[]"
        }
      ],
      "name": "configureSpeciesBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint128[][]",
          "name": "predictedRevenues",
          "type": "uint128[][]"
        },
        {
          "internalType": "uint64[][]",
          "name": "claimTimestamps",
          "type": "uint64[][]"
        }
      ],
      "name": "configureSpeciesConfig",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8[]",
          "name": "yearStageCounts",
          "type": "uint8[]"
        },
        {
          "internalType": "uint64[]",
          "name": "costs",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "prices",
          "type": "uint64[]"
        }
      ],
      "name": "configureStages",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "currentBatchYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "currentStageIndex",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositRevenue",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "farmer",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "farmerFee",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "finalizeSpecies",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "getExchangeRateWad",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        }
      ],
      "name": "getHarvest",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "timestamp",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "quantity",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "pricePerUnit",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "totalRevenue",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "getHarvestCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "speciesId",
          "type": "uint256"
        }
      ],
      "name": "getRefundableByUser",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcAmount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        }
      ],
      "name": "getRefundableByUserAllSpecies",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcAmount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "getSpeciesConfig",
      "outputs": [
        {
          "internalType": "uint128",
          "name": "predictedRevenue",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "realizedRevenue",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "circulatingSupply",
          "type": "uint128"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        },
        {
          "internalType": "bool",
          "name": "configured",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "finalized",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "getStageInfo",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "cost",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "price",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "raised",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "feeCollected_",
          "type": "uint64"
        },
        {
          "internalType": "bool",
          "name": "signed",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "audited",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "withdrawn",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "speciesId",
          "type": "uint256"
        }
      ],
      "name": "getToBurnByUser",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        }
      ],
      "name": "getToBurnByUserAllSpecies",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "getYearStages",
      "outputs": [
        {
          "internalType": "uint64[]",
          "name": "costs",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "prices",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "raised",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "feesCollected",
          "type": "uint64[]"
        },
        {
          "internalType": "bool[]",
          "name": "signed",
          "type": "bool[]"
        },
        {
          "internalType": "bool[]",
          "name": "audited",
          "type": "bool[]"
        },
        {
          "internalType": "bool[]",
          "name": "withdrawn",
          "type": "bool[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_stableCoin",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_farmer",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_auditor",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_usdcTreasuryAddress",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_factory",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "_maxYear",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "_speciesCount",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "_investorFee",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "_treasuryAddress",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "_farmerFee",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "_investmentToken",
          "type": "address"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint64",
          "name": "amount",
          "type": "uint64"
        }
      ],
      "name": "invest",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "investmentToken",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "investorFee",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "investorFeeTotal",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "markProjectFailed",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "maxProjectYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextAuditStageIndex",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextAuditYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextSignStageIndex",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextSignYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "refundAmount",
          "type": "uint256"
        }
      ],
      "name": "payoutRefund",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectCompleted",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectFailed",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "quantity",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "pricePerUnit",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "totalRevenue",
          "type": "uint64"
        }
      ],
      "name": "recordHarvest",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "_enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_yieldRouter",
          "type": "address"
        }
      ],
      "name": "setYieldRouter",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "signStage",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "speciesConfigPointer",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "speciesCount",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "stageCountForYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stagesConfigured",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "startAudit",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalRefundReserved",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalStageCount",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "treasuryAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdcTreasuryAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "withdrawFunds",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawInvestorFees",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "yieldRouter",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default AgroforestryProject;
